import { render, staticRenderFns } from "./GameCollectionDetail.vue?vue&type=template&id=b1c5e3e8"
import script from "./GameCollectionDetail.vue?vue&type=script&lang=js"
export * from "./GameCollectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports